import { useMatomo } from '@datapunt/matomo-tracker-react';
import React, { useEffect, useState } from 'react';

import Header from '@components/common/Header/Header';

import useTranslation from '@hooks/useTranslation';

import FilterPanel from './components/FilterPanel/FilterPanel';
import NewsList from './components/NewsList/NewsList';
import style from './style.module.scss';

const WhatsNew = () => {
  const { trackPageView } = useMatomo();
  const { t } = useTranslation();

  const [searchValue, setSearchValue] = useState('');

  useEffect(() => {
    trackPageView({});
  }, []);

  return (
    <div className={style.whatsNewPage}>
      <Header title={t("What's New")} showLogo={true} />
      <div className={style.whatsNewBody}>
        <FilterPanel searchValue={searchValue} setSearchValue={setSearchValue} />
        <NewsList searchValue={searchValue} />
      </div>
    </div>
  );
};

export default WhatsNew;
